import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Intent, InputGroup, TextArea } from '@blueprintjs/core';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
import styled from 'styled-components';

import SelectFacility from 'components/elements/select-facility';
import DateInput from 'components/elements/date-input';
import DateRangeInput from 'components/elements/date-range-input';
import IconRequired from 'components/elements/required-icon';
import { DATE_FORMAT } from 'config';
import Clearfix from 'components/elements/clearfix';
import { convertDateFromSever as convertDate } from 'utils/fnUtil';
// import dynamicRoleHOC from 'hoc/dynamicRole';
import { COLOR } from 'config';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

// @dynamicRoleHOC()
class AuditForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    onSubmit: PropTypes.func,
  };

  setInitialValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;
      return value;
    }
    return defaultValue;
  }

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);
      if (!selItem) return defaultValue;
      return {
        value: selItem._id,
        label: nameLabel ? selItem[nameLabel] : selItem.Name,
      };
    }
    return defaultValue;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      if (error) return;

      if (value.facilities) {
        value.facilities = value.facilities.map((item) => item.value);
      }
      // console.log(value);
      if (this.props.onSubmit) this.props.onSubmit(value);
    });
  };

  onSuccessUpload = (res) => {
    if (res) {
      this.props.form.setFieldsValue({
        complianceFile: res,
      });
    }
  };

  render() {
    const { getFieldProps, getFieldError } = this.props.form;

    return (
      <div>
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Kế hoạch kiểm tra
        </h4>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={this.submit}
                style={{color: COLOR.SUCCESS}}
              />
              <Clearfix width={8} />
              {/* <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}> */}
              <Icon
                onClick={() => {
                  window.history.back();
                }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
              />
              {/* </Link> */}
            </HeaderContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Danh sách tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <SelectFacility
              isMulti
              isDisabled={this.props.facility ? true : false}
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'facilities',
                option: {
                  initialValue: this.setInitialValue('facilities', null),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn cơ sở',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('facilities') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Số quyết định đoàn kiểm tra
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Số quyết định đoàn kiểm tra'
              {...getFieldProps('AuditNumber', {
                initialValue: this.setInitialValue('AuditNumber', ''),
                rules: [
                  {
                    validator: (rule, val, callback) => {
                      if(!(val || '').trim()) callback(new Error('Vui lòng nhập số quyết định'))
                      callback()
                    },
                  },
                  {
                    min: 3,
                    max: 64,
                    message: 'Số quyết định có độ dài từ 3 -> 64 kí tự',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('AuditNumber') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Thời gian kiểm tra <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <DateRangeInput
              singleMonthOnly={true}
              shortcuts={false}
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              {...getFieldProps('AuditDate', {
                initialValue: this.props.isEdit
                  ? [
                      convertDate(
                        this.setInitialValue('AuditDate')
                          ? this.setInitialValue('AuditDate')[0]
                          : null
                      ),
                      convertDate(
                        this.setInitialValue('AuditDate')
                          ? this.setInitialValue('AuditDate')[1]
                          : null
                      ),
                    ]
                  : undefined,
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập ngày kiểm tra',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('AuditDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngày ra quyết định</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày ra quyết định'
              {...getFieldProps('DecideDate', {
                initialValue: convertDate(
                  this.setInitialValue('DecideDate', null)
                ),
              })}
            />
            <ErrorContainer>
              {(getFieldError('DecideDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Cơ quan ban hành</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Cơ quan ban hành'
              {...getFieldProps('AgencyIssued', {
                initialValue: this.setInitialValue('AgencyIssued', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ghi chú kế hoạch kiểm tra</LabelContainer>
          </Col>
          <Col xs={4}>
            <TextArea
              fill
              {...getFieldProps('Notes', {
                initialValue: this.setInitialValue('Notes', null),
              })}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default createForm()(AuditForm);



// WEBPACK FOOTER //
// ./src/containers/FacilityAudit/AuditForm/index.js